import React from "react";

export default function SocialIcon({ ...props }) {
    return (
        <a className="social--icon" target={'_blank'} rel={'noreferrer'} href={props.url}>
            <img
                src={props.image}
                alt={props.title}
            />
        </a>
    )
}
